import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { AccessTokens, GeneralSettingsState } from './generalSettinsTypes';

const initialState: GeneralSettingsState = { exportV4ApiKeyLoading: false, accessTokens: {} };

const generalSettingsSlice = createSlice({
  name: 'generalSettings',
  initialState,
  reducers: {
    setExportV4ApiKey(state, action) {
      state.exportV4ApiKey = action.payload;
    },
    setExportV4ApiKeyLoading(state, action) {
      state.exportV4ApiKeyLoading = action.payload;
    },
    clearExportV4ApiKey(state) {
      state.exportV4ApiKey = undefined;
    },
    setAccessTokens(state, action: PayloadAction<Record<string, AccessTokens>>) {
      state.accessTokens = { ...state.accessTokens, ...action.payload };
    }
  }
});

export const generalSettingsReducer = generalSettingsSlice.reducer;
export const generalSettingsActions = generalSettingsSlice.actions;

export const {
  setExportV4ApiKey,
  clearExportV4ApiKey,
  setExportV4ApiKeyLoading,
  setAccessTokens
} = generalSettingsActions;
